"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SelectField_1 = __importDefault(require("./SelectField"));
var FormFields_1 = require("./FormFields");
var Form_1 = require("./Form");
var useTimezones = function () {
    var _a = react_1.useState(null), timezones = _a[0], setTimezones = _a[1];
    react_1.useEffect(function () {
        var cancelled = false;
        Promise.resolve().then(function () { return __importStar(require("../../timezones.json")); }).then(function (_a) {
            var timezonesJson = _a.default;
            if (!cancelled) {
                setTimezones(timezonesJson);
            }
        }).catch(function () {
            // this catch is here because in the case that you're not in an
            // environment that supports dynamic import (like jest when you're not
            // compiling vendored code) it will spam the console otherwise
        });
        return function () {
            cancelled = true;
        };
    }, [setTimezones]);
    return timezones;
};
var TimezoneField = function (_a) {
    var onChange = _a.onChange, onOffsetChange = _a.onOffsetChange, props = __rest(_a, ["onChange", "onOffsetChange"]);
    var values = Form_1.useForm().values;
    var timezones = useTimezones();
    react_1.useEffect(function () {
        if (timezones && onOffsetChange) {
            var name_1 = props.name, value = props.value;
            var normal_1 = value || values[name_1];
            var match = timezones.find(function (timezone) { return timezone.value === normal_1; });
            if (match) {
                onOffsetChange(match.offset);
            }
        }
    }, 
    // Here we're going to explicitly ignore the rules of hooks because we only
    // want this to fire when the timezones are fetched mounts and not in
    // relation to its component props.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [timezones]);
    var handleChange = function (nextValue) {
        if (onChange) {
            onChange(nextValue);
        }
        if (timezones) {
            var match = timezones.find(function (timezone) { return timezone.value === nextValue; });
            if (match && onOffsetChange) {
                onOffsetChange(match.offset);
            }
        }
    };
    if (!timezones) {
        return react_1.default.createElement(FormFields_1.StringField, __assign({}, props, { onChange: handleChange }));
    }
    // const candidates = timezones as unknown as Timezones;
    return react_1.default.createElement(SelectField_1.default, __assign({}, props, { onChange: handleChange, options: timezones }));
};
exports.default = TimezoneField;
